import React, { Component } from "react";
import clsx from "clsx";
import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  Cell,
  CartesianGrid,
} from "recharts";

import {
  selectFormat,
  MAIN_COLORS,
  CustomizedYAxisTick,
  StandardTooltip,
} from "./../Utils/Utils.js";

import { getXrayTooltipPosition } from "helpers/DOM";

class BarChartLegends extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      height: 0,
      tooltip: {
        show: false,
        x: 0,
        y: 0,
      },
    };

    this.divPosition = React.createRef();

    this.updatePosition = this.updatePosition.bind(this);
  }

  updatePosition() {
    this.closeTooltip();
    if (!this.chartRef) return;
    const { containerWidth, containerHeight } = this.chartRef.state;
    this.setState({ width: containerWidth, height: containerHeight });
  }

  UNSAFE_componentWillMount() {
    this.updatePosition();
  }

  componentDidMount() {
    this.props.childRef(this);

    window.addEventListener("resize", this.updatePosition);
    window.addEventListener("click", this.handleClickOutside);

    setTimeout(() => {
      this.updatePosition();
    }, 500);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePosition);
    window.removeEventListener("click", this.handleClickOutside);
  }

  renderBars = (data) => {
    let bars = [];

    data
      .map((e) => Object.keys(e)[0])
      .forEach((bar, i) => {
        bars.push(
          <Bar
            key={i}
            dataKey={bar}
            fill={MAIN_COLORS[i]}
            barSize={125}
            cursor="pointer"
          />
        );
      });

    return bars;
  };

  legendElement = (data) => {
    return data.map((entry, i) => {
      return (
        <span key={i} className="legend mt-2 mt-md-0">
          <span
            className="legend__icon"
            style={{ background: MAIN_COLORS[i] }}
          ></span>
          <span className="legend__text" style={{ color: MAIN_COLORS[i] }}>
            {entry}
          </span>
        </span>
      );
    });
  };

  /**
   * Renders each element name into legend
   */
  renderLegends = (data) => {
    let legends = data.map((e) => e.name);

    return <div> {this.legendElement(legends)} </div>;
  };

  /**
   * Converts each Element name into Name attribute
   */
  prepareData = (data) => {
    return data
      .sort((a, b) => a.value - b.value)
      .map((e, idx) => {
        return {
          ...e,
          idx,
        };
      });
  };

  clickBar(d) {
    if (this.state.tooltip.show) {
      this.setState({
        tooltip: { ...d, show: false },
      });
    } else {
      this.setState({
        tooltip: { ...d, show: true },
      });
    }
  }

  closeTooltip() {
    this.setState({
      tooltip: { show: false },
    });
  }

  handleClickOutside = (e) => {
    if (
      this.divPosition.current &&
      this.divPosition.current.contains(e.target)
    ) {
      return;
    } else {
      this.closeTooltip();
    }
  };

  render() {
    let { data } = this.props;
    data = this.prepareData(data.data);
    const labels = [];
    return (
      <React.Fragment>
        <div ref={this.divPosition}>
          {this.renderLegends(data)}
          <ResponsiveContainer height={350} width="100%">
            <BarChart
              data={data}
              margin={{ top: 12, right: 0, bottom: 0, left: -38 }}
              onClick={(d) => {
                const label = labels.filter((l) => l.date === d.date);
                const extra = {
                  key: d.activePayload[0].payload.name,
                  value: d.activePayload[0].payload.value,
                  color: MAIN_COLORS[d.activePayload[0].payload.idx],
                };

                d.extra = extra;
                d.insight = label.length ? label[0] : null;

                this.clickBar(d);
              }}
            >
              <CartesianGrid
                stroke="#FEE5DE"
                strokeDasharray="3 3"
                vertical={false}
              />

              <Bar dataKey={"value"}>
                {data.map((entry, index) => (
                  <Cell fill={MAIN_COLORS[index]} key={`cell-${index}`} />
                ))}
              </Bar>
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      const payload = data(this.props);

                      if (payload !== null) {
                        const tooltip_data = payload[0].payload;
                        return (
                          <div className="standard-tooltip">
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                {tooltip_data.name}
                              </span>
                            </header>
                            <main className="standard-tooltip__main">
                              <div className="standard-tooltip__item">
                                <span
                                  className="standard-tooltip__icon"
                                  style={{
                                    background: MAIN_COLORS[tooltip_data.idx],
                                  }}
                                ></span>
                                <span
                                  className={clsx(
                                    "standard-tooltip__key",
                                    "text-capitalize"
                                  )}
                                  style={{
                                    color: MAIN_COLORS[tooltip_data.idx],
                                  }}
                                >
                                  {tooltip_data.name}{" "}
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat("number", tooltip_data.value)}
                                </span>
                              </div>
                            </main>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />

              <YAxis
                axisLine={false}
                tickLine={false}
                tickFormatter={(d) => selectFormat("number", d)}
                tick={<CustomizedYAxisTick />}
              />
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltip.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top: "80px",
                left:
                  this.state.tooltip.activeCoordinate.x + 1062 + 220 <
                  this.state.width
                    ? this.state.tooltip.activeCoordinate.x + 15 + "px"
                    : this.state.tooltip.activeCoordinate.x -
                      getXrayTooltipPosition(
                        this.divPosition.current,
                        this.state.tooltip.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltip.show ? 1.0 : 0.0,
                visibility: this.state.tooltip.show ? "visible" : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltip}
                close={this.closeTooltip.bind(this)}
              />
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

const XRayTooltip = (props) => {
  const { data } = props;

  const extra = data.extra ? data.extra : null;
  if (extra !== null) {
    return (
      <div className="standard-tooltip">
        <header className="standard-tooltip__header">
          <span className="standard-tooltip__key-header">{data.extra.key}</span>
          <span className="close-icon" onClick={() => props.close()}></span>
        </header>
        <main className="standard-tooltip__main">
          <div className="standard-tooltip__item">
            <span
              className="standard-tooltip__icon"
              style={{
                background: MAIN_COLORS[data.activePayload[0].payload.idx],
              }}
            ></span>
            <span
              className={clsx("standard-tooltip__key", "text-capitalize")}
              style={{ color: MAIN_COLORS[data.activePayload[0].payload.idx] }}
            >
              {data.extra.key}{" "}
            </span>
            <span className="standard-tooltip__value">
              {selectFormat("number", data.extra.value)}
            </span>
          </div>
        </main>
      </div>
    );
  } else {
    return null;
  }
};

export default BarChartLegends;
